<nb-card>
  <nb-card-header>Add Role</nb-card-header>
  <nb-card-body>
    <div class="text-center m-t-20">
      <b>To add the Club Staff role you must first complete the following information?</b>
    </div>
    <form [formGroup]="form">
      <div class="row m-t-10">
        <div class="col-12" style="margin-bottom: -10px;">
          <mat-form-field appearance="standard" floatLabel="always">
            <mat-label>Sport</mat-label>
            <mat-select formControlName="sport" placeholder="Select One">
                <mat-option *ngFor="let sport of sports" [value]="sport">
                    <span style="text-transform: capitalize;"> {{sport.value}}</span>
                </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row" *ngIf="form.get('club')">
        <div class="col-12">
          <mat-form-field floatLabel="always">
            <mat-label>Club</mat-label>
            <input type="text" placeholder="Select One" aria-label="Club" matInput formControlName="club"
              [matAutocomplete]="auto2">
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnClub">
              <ng-container *ngIf="filteredClubsOptions$ | async as clubs">
                <div *ngIf="clubs.length > 0">
                  <mat-option *ngFor="let club of clubs" [value]="club">
                    {{club.name}}</mat-option>
                </div>
              </ng-container>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="row m-t-10">
        <div class="col-12" style="margin-bottom: -10px;">
          <mat-form-field style="width: 100%;" floatLabel="always">
            <mat-label>Job Title</mat-label>
            <mat-select formControlName="jobTitle" placeholder="Select One">
              <mat-option *ngFor="let job of jobsTitle" [value]="job">
                {{job.value}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </form>
    <div class="row" fxLayoutAlign="start" class="p-t-10">
      <dl>
        <span>
          If you cannot find your club, you can incorporate it by contacting us at
          clubs@sportstf.com.
        </span>
      </dl>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="modal-footer">
      <button nbButton matRipple ghost status="warning" (click)="dismiss(false)">Cancel</button>
      <button nbButton matRipple status="primary" #yesButton id="yesButton" [disabled]="form.invalid"
        (click)="dismiss(true)">Add Role</button>
    </div>
  </nb-card-footer>
</nb-card>